import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { Camera, X, SwitchCamera, Zap } from 'lucide-react';

const BarcodeScannerModal = ({ isOpen, onClose, onScan }) => {
  const scannerRef = useRef(null);
  const containerRef = useRef(null);
  const [error, setError] = useState('');
  const [facingMode, setFacingMode] = useState('environment');

  useEffect(() => {
    if (!isOpen) return;
    let scanner = null;
    const startScanner = async () => {
      setError('');
      const id = 'barcode-scanner-region';
      try {
        scanner = new Html5Qrcode(id);
        scannerRef.current = scanner;
        await scanner.start(
          { facingMode },
          { fps: 15, qrbox: { width: 280, height: 120 }, aspectRatio: 1.5, disableFlip: false },
          (decodedText) => {
            onScan(decodedText);
            scanner.stop().catch(() => {});
            onClose();
          },
          () => {}
        );
      } catch (err) {
        setError(err?.message || 'Camera non disponible');
      }
    };
    const timer = setTimeout(startScanner, 100);
    return () => {
      clearTimeout(timer);
      if (scannerRef.current) {
        scannerRef.current.stop().catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [isOpen, facingMode]);

  const toggleCamera = () => {
    setFacingMode(f => f === 'environment' ? 'user' : 'environment');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/80 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-[#0a0a12] border border-white/10 rounded-2xl w-full max-w-md overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <div className="flex items-center gap-2">
            <Camera className="w-5 h-5 text-cyan-400" />
            <h3 className="text-white font-bold text-sm">Scanner code-barres</h3>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={toggleCamera} className="p-2 rounded-lg bg-white/10 hover:bg-white/20 text-gray-300 transition-colors" title="Changer camera">
              <SwitchCamera className="w-4 h-4" />
            </button>
            <button onClick={onClose} className="p-2 rounded-lg bg-white/10 hover:bg-white/20 text-gray-300 transition-colors">
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
        <div className="relative" ref={containerRef}>
          <div id="barcode-scanner-region" className="w-full" style={{ minHeight: 300 }}></div>
          {error && (
            <div className="absolute inset-0 flex items-center justify-center bg-black/60">
              <div className="text-center p-4">
                <Zap className="w-8 h-8 text-amber-400 mx-auto mb-2" />
                <p className="text-amber-400 text-sm font-medium">{error}</p>
                <p className="text-gray-500 text-xs mt-1">Verifiez les permissions camera</p>
              </div>
            </div>
          )}
        </div>
        <div className="p-3 text-center border-t border-white/10">
          <p className="text-xs text-gray-500">Placez le code-barres dans le cadre</p>
        </div>
      </div>
    </div>
  );
};

export default BarcodeScannerModal;
